module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/home/HOME_betterliving.png";